import { Button, Input } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC, useState } from "react";

const { Search } = Input;

import FormFieldData = App.Data.FormFieldData;

interface FormFieldParentFieldFormProps {
    formField: FormFieldData;
    parentFormFields: FormFieldData[];
    handleClick: (id: string | null) => void;
    activeItem: string | null;
}

export const FormFieldParentFieldSelector: FC<FormFieldParentFieldFormProps> = ({
    formField,
    parentFormFields,
    handleClick,
    activeItem,
}) => {
    const { t } = usePaldockTranslation("common");
    const [search, setSearch] = useState("");

    return (
        <div className={"max-w-xl"}>
            <Search
                size="large"
                placeholder={t("search")}
                onChange={(e) => setSearch(e.target.value)}
                className="mb-4"
            />

            <Button
                type={formField && activeItem === null ? "primary" : "default"}
                onClick={() => handleClick(null)}
                className="m-1"
            >
                {t("not_selected")}
            </Button>

            {parentFormFields
                ?.filter((item) => item?.system_name?.includes(search))
                ?.map((item) => (
                    <Button
                        key={item.id}
                        type={formField && activeItem === item.id ? "primary" : "default"}
                        onClick={() => handleClick(item.id || null)}
                        className="m-1"
                    >
                        {item.system_name}
                    </Button>
                ))}
        </div>
    );
};
